"use strict";

const { produceXMLSerialization } = require("./serialization");
const XMLSerializer = require("./XMLSerializer");

module.exports = {
  XMLSerializer,
  produceXMLSerialization
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/w3c-xmlserializer/lib/index.js
// module id = eV4T
// module chunks = 0